var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.9869975,11.25 C13.9869975,6.98888889 19.7886641,6.91787037 19.982053,11.0369444 L19.9869975,11.25 L19.986,16.1663945 L20.0989975,16.13 C21.5389975,15.6966667 23.2789975,16.3466667 23.8189975,18.08 L23.856,18.2143945 L23.956053,18.1769444 C25.4216641,17.654537 27.2609975,18.2888889 27.8189975,20.08 L27.856,20.2143945 L27.956053,20.1769444 C29.658053,19.5702778 31.864053,20.5236111 31.982053,23.0369444 L31.9869975,23.25 L31.9869975,35.24 C31.9869975,36.8408198 30.7899365,38.1531836 29.2208316,38.244882 L29.0449975,38.25 L17.0439975,38.25 C16.3257515,38.25 15.6062184,37.9774136 15.0604341,37.5011326 L14.9160232,37.3662393 L6.90870179,29.3619178 C5.64096388,28.0935024 5.74854315,26.2998594 6.91082591,25.1315877 C8.03131857,24.0053213 9.73560303,23.8591486 10.9959477,24.9855107 L11.1393435,25.1211396 L13.986,27.9853945 L13.9869975,11.25 Z M25.9869975,21.25 C25.9869975,19.6354167 24.1100443,19.5849609 23.9927348,21.0986328 L23.9869975,21.25 L21.9869975,21.25 L21.9869975,19.25 C21.9869975,17.6354167 20.1100443,17.5849609 19.9927348,19.0986328 L19.9869975,19.25 L17.9869975,19.25 L17.9869975,11.25 C17.9869975,9.63541667 16.1100443,9.58496094 15.9927348,11.0986328 L15.9869975,11.25 L15.9869975,32.8370844 L9.72289068,26.5331068 C9.27730696,26.0875231 8.74788916,26.120782 8.32866901,26.5421623 C7.93811537,26.9347284 7.88252104,27.424565 8.23448218,27.8506407 L8.32297174,27.9477607 L16.3301042,35.9518932 C16.4834239,36.1052128 16.7007735,36.2100184 16.9157949,36.2406947 L17.0439975,36.25 L29.0449975,36.25 C29.5355494,36.25 29.927311,35.875955 29.9807741,35.361185 L29.9869975,35.24 L29.9869975,23.25 C29.9869975,21.6354167 28.1100443,21.5849609 27.9927348,23.0986328 L27.9869975,23.25 L25.9869975,23.25 L25.9869975,21.25 Z M18,2 L18,7 L16,7 L16,2 L18,2 Z M22.2928932,3.29289322 L23.7071068,4.70710678 L20.7071068,7.70710678 L19.2928932,6.29289322 L22.2928932,3.29289322 Z M11.7071068,3.29289322 L14.7071068,6.29289322 L13.2928932,7.70710678 L10.2928932,4.70710678 L11.7071068,3.29289322 Z",
    id: ".._.._src_svg_Icn_40px_Hand_Click__path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-23.1%",
    y: "-16.6%",
    width: "146.2%",
    height: "133.1%",
    filterUnits: "objectBoundingBox",
    id: ".._.._src_svg_Icn_40px_Hand_Click__filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Hand_Click__Icn/40px/Hand_Click",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Hand_Click__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Hand_Click__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Hand_Click__Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 1,
    filter: "url(#.._.._src_svg_Icn_40px_Hand_Click__filter-2)",
    xlinkHref: "#.._.._src_svg_Icn_40px_Hand_Click__path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#.._.._src_svg_Icn_40px_Hand_Click__path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandClick);
export default __webpack_public_path__ + "static/media/Hand_Click.bddd696e29f6dc9e13b7900eb5969c6b.svg";
export { ForwardRef as ReactComponent };